/** ADR-172 D5 — the actor chip: a name, with the stored value in the tooltip. */
import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { getChipSx } from '../../../constants/chipPalette';
import { actorLabel, actorDetail, isMachineActor } from './actorDisplay';

const ActorChip = ({ actor }) => {
  let tone = 'info';
  if (isMachineActor(actor)) {
    tone = 'default';
  } else if (actor?.unattributed) {
    tone = 'error';
  }
  return (
    <Tooltip title={actorDetail(actor)}>
      <Chip size="small" label={actorLabel(actor)} sx={getChipSx(tone)} />
    </Tooltip>
  );
};

export default ActorChip;
